/* global jQuery COMPONENTS */

COMPONENTS.ComponentSpaces = (function ($) {
  function ComponentSpaces () {
    this.$component = $('[data-ecs-component="component-spaces"]')
    this.$spacesWrapper = $('[data-ecs-component="component-spaces-inventory"]')
    this.$mapElem = this.$component.find('[data-spaces-control="map"]')
    this.$maxZoom = parseInt(this.$spacesWrapper.data('ecs-max-zoom'), 10) || 15 // Default to 15 if not set or invalid
  }

  ComponentSpaces.prototype.init = function () {
      const component = this

      const observer = new MutationObserver((mutations, obs) => {
        const mapDiv = component.$mapElem[0]

        // Check if the Google Map exists
        if (mapDiv && mapDiv.firstChild) {
          const mapInstance = window.SPACES && window.SPACES.communityMap

          // Verify the instance exists and has the setOptions method
          if (mapInstance && typeof mapInstance.setOptions === 'function') {
            mapInstance.setOptions({ maxZoom: component.$maxZoom })

            // console.log('Success: communityMap zoom restricted to', component.$maxZoom)
            obs.disconnect() // Stop observing once the change is applied
          }
        }
      })

      // Start watching the map element specifically for the Google Map injection
      if (component.$mapElem.length) {
        observer.observe(component.$mapElem[0], { childList: true, subtree: true })
      }
    }

  return ComponentSpaces
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentSpaces = new COMPONENTS.ComponentSpaces()
  COMPONENTS.ComponentSpaces.init()
})
